import React from 'react'
import { useDispatch } from 'react-redux'
import { setModal } from 'slices/modal'
import { STATICS } from 'statics'
import { FIREBASE_EVENTS, MODAL_KEYS } from 'app-constants'
import { useFirebaseEvent } from 'hooks'
import { BaseCard } from '../base-card'

export function FileSendCard() {
  const dispatch = useDispatch()
  const { sendEvent } = useFirebaseEvent()

  function handleClick() {
    sendEvent(FIREBASE_EVENTS.CLICK_ON_SEND_FILE)
    dispatch(setModal({ key: MODAL_KEYS.FILE_UPLOAD }))
  }

  return <BaseCard onClick={handleClick} text='Envio de arquivo' icon={<STATICS.UPLOAD />} />
}
